export const BASE_URL = process.env.REACT_APP_BASE_URL + "admin/";
export const BASE_URL_REPORTS = process.env.REACT_APP_BASE_URL_REPORTS;
export const POS_BASE_URL = process.env.REACT_APP_BASE_URL;
export const ACTIVITY_LOG_URL = process.env.REACT_APP_ACTIVITY_LOG_API_KEY;
export const ACTIVITY_LOG_PROJECT_KEY =
  process.env.REACT_APP_ACTIVITY_LOG_PROJECT_KEY;
export const CMS_URL = process.env.REACT_APP_CMS_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const CONNECT_SITE_URL = process.env.REACT_APP_CONNECT_SITE_URL;
